document.addEventListener('DOMContentLoaded', function () {

    let videoSwiper = document.querySelectorAll('[data-video-swiper]');

    videoSwiper.forEach(el => {
        if(typeof(el) != 'undefined' && el != null) {
            let videoSwiperEl = new Swiper(el, {
                slidesPerView: 4,
                spaceBetween: 50,
                loop: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1
                    },
                    767: {
                        slidesPerView: 2
                    },
                    980: {
                        slidesPerView: 3
                    },
                    1366: {
                        slidesPerView: 4
                    }
                }
            });
        }
    });
});